import React, { Component, Link } from 'react';
import { NavDropdown, MenuItem, NavItem } from 'react-bootstrap';
import './index.css';

export default class DropdownMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: { main_menu: [], ...props.data },
      config: { config: [], ...props.config }
    }
  }



  render() {
    // console.log("DropdownMenu data: ", this.state.data);
    // console.log("DropdownMenu config: ", this.state.config);
    const mainColor = "#" + this.state.config.gbcolor
    return (
      <NavDropdown className="DropdownMenu menu-fix" noCaret title={this.props.children} id="basic-nav-dropdown" style={{ zIndex: 999999 }}>

        <MenuItem className="closeNavItem" style={{ backgroundColor: '#' + this.state.config.gbcolor }}></MenuItem>
        {/* {this.state.data.hamburger_menu.map((item) =>
          <MenuItem className="dropdownMenuItem" style={{ backgroundColor: '#' + this.state.config.gbcolor }} eventKey={item.id} href={item.url} key={item.id}>{item.title}</MenuItem>
        )} */}
        
        {this.state.data.hamburger_menu ? (
          
            this.state.data.hamburger_menu.map(function (item, index) {
              const submenu = item.sub_menu ? item.sub_menu.map(function (subItem, subIndex) {
                return (
                  <div style={{ backgroundColor: mainColor }} key={subIndex}>
                    <a href={subItem.url}>{subItem.name}</a>
                  </div>
                )
              }) : null

              return (
                <div key={index} style={{ backgroundColor: mainColor }}>
                  <MenuItem className="dropdownMenuItem" eventKey={item.id} href={item.url}>{item.title}</MenuItem>
                  <div className="custom-submenu">
                    {submenu}
                  </div>
                </div>
              )
            })
          
        ) : (
          
          this.state.data.main_menu.map((item) =>
            <MenuItem className= "dropdownMenuItem" style={{backgroundColor: '#'+this.state.config.gbcolor}} eventKey={item.id} href={item.url} key={item.id}>{item.name}</MenuItem>
          )
        )}
      </NavDropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/DropdownMenu/index.js